export const USER_TYPE = {
  NORMAL: 'normal',
  INVITED: 'invited',
  ADOPTED: 'adopted'
};
